/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Agent_Knowledge_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Pick the spaces that hold what the job needs, such as the support space for a ticket summary. Fewer, well-chosen spaces give more focused answers." |
*
* @param {Uno_Edu_Agent_Knowledge_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_agent_knowledge_chip1_answer = /** @type {((inputs?: Uno_Edu_Agent_Knowledge_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Agent_Knowledge_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Bereiche, in denen steht, was die Aufgabe braucht, etwa den Support-Bereich für eine Ticket-Übersicht. Wenige, gut gewählte Bereiche geben gezieltere Antworten.")
	return /** @type {LocalizedString} */ ("Pick the spaces that hold what the job needs, such as the support space for a ticket summary. Fewer, well-chosen spaces give more focused answers.")
});